import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { COGNITO_DOMAIN, COGNITO_CLIENT_ID, REDIRECT_URI } from "../authConfig";

export default function Callback() {
  const already = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (already.current) return;
    already.current = true;

    const url = new URLSearchParams(window.location.search);
    const code = url.get("code");

    if (!code) {
      console.error("❌ No code received");
      return;
    }

    async function run() {
      const params = new URLSearchParams({
        grant_type: "authorization_code",
        client_id: COGNITO_CLIENT_ID,
        code,
        redirect_uri: REDIRECT_URI
      });

      const res = await fetch(`${COGNITO_DOMAIN}/oauth2/token`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params
      });

      const data = await res.json();

      if (!data.id_token) {
        console.error("❌ Error exchanging token:", data);
        return;
      }

      // Guardar tokens ANTES de redirigir
      localStorage.setItem("idToken", data.id_token);
      localStorage.setItem("accessToken", data.access_token);

      // 🔥 Redirección limpia sin reiniciar el DOM
      navigate("/");
    }

    run();
  }, []);

  return <h2>Validando sesión...</h2>;
}
